import React from 'react';

import styled from '@emotion/styled';

import { ExternalLinkButton } from '../../../../components/Button/ExternalLinkButton';
import InfoIcon from '../../../../components/Icons/InfoIcon';
import {
  SegmentedView,
  SegmentedViewController,
  SegmentedViewData,
} from '../../../../components/SegmentedViewController';

const segmentedViewControllerTitle = [
  { title: 'Registered Driver' },
  { title: 'View Driver History' },
  { title: 'Rate Driver' },
];

const AboutTheApi = () => {
  return (
    <Container>
      <TitleArea>
        <InfoIcon />
        <div>About this API</div>
      </TitleArea>
      <SegmentControlArea>
        <SegmentedView>
          <SegmentedViewController
            className='mobile-thin'
            segmentedViewControllerTitle={segmentedViewControllerTitle}
          />
          <SegmentedViewData>
            <Section>
              <Summary>Summary</Summary>
              <section>
                This API endpoint allows clients to register a driver's
                information, generating a unique Tracing ID. This ID serves as a
                persistent identifier, enabling the system to associate all
                future work history and behavioral data with the driver within
                the database.
              </section>
              <section>
                The driver's National Identification Number (NIN) serves as the
                unique Tracing ID. This identifier persists across all job
                history entries, enabling the platform to track the driver's
                work records and aggregate data for performance ratings and
                behavioural insights.
              </section>
              <ExternalLinkButton
                href='https://documenter.getpostman.com/view/56055378/2sBY4QsKu7'
                className='borderless'
              >
                View Documentation
              </ExternalLinkButton>
            </Section>
            <Section>
              <Summary>Summary</Summary>
              <section>
                This API endpoint facilitates the retrieval of a driver's
                comprehensive work history by aggregating data across all
                registered companies within the Logirate ecosystem. It provides
                a unified and authoritative source of historical engagement
                records to support informed decision-making.
              </section>
              <section>
                Clients can also access detailed metrics and analytics on driver
                performance, including delivery punctuality, customer
                satisfaction ratings, and additional behavioral insights that
                support operational optimization. Overall driver ratings and
                their implications for your organization are available,
                providing actionable insights to inform hiring decisions,
                strengthen operations teams, and drive revenue growth.
              </section>
              <ExternalLinkButton
                href='https://documenter.getpostman.com/view/56055378/2sBY4QsKu7'
                className='borderless'
              >
                View our postman documentation here
              </ExternalLinkButton>
            </Section>
            <Section>
              <Summary>Summary</Summary>
              <section>
                This API endpoint streamlines the process for companies to
                submit driver performance evaluations at contract completion or
                termination. It also consolidates customer delivery feedback to
                produce actionable insights that comprehensively assess the
                driver's work ethic and overall reliability.
              </section>
              <section>
                This API is designed to integrate seamlessly into your in-app
                rating flow or post-trip customer receipt system. By capturing
                real-time feedback on delivery experiences, it equips operations
                teams with actionable data to identify service issues, trace
                them to specific drivers, and drive continuous performance
                improvement.
              </section>
              <ExternalLinkButton
                href='https://documenter.getpostman.com/view/56055378/2sBY4QsKu7'
                className='borderless'
              >
                View our postman documentation here
              </ExternalLinkButton>
            </Section>
          </SegmentedViewData>
        </SegmentedView>
      </SegmentControlArea>
    </Container>
  );
};

export default AboutTheApi;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4px;
  gap: 16px;
  /* background-color: #fff; */
`;

const TitleArea = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px;
  align-items: center;
  font-size: 17px;
  line-height: 18px;
  font-weight: 600;
`;

const SegmentControlArea = styled.div`
  display: flex;
`;

const Section = styled.section`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  flex-direction: column;
  gap: 16px;
  padding: 31px;
  border-radius: 6px;

  @media (max-width: 884px) {
    font-size: 13px;
    background-color: #fff;
  }
`;

const Summary = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 17px;
  line-height: 17px;
`;
